// @ts-nocheck
import React from "react";

// The graph's view switch, on the group page's segmented control. It used to be a dropdown that showed only the view you were NOT on, so nothing on screen said where you were — the same problem the group page's view row had. Every view is a visible option now, which also retires the absolutely-positioned z-[100] popup this used to float over the chart.
const TabViewSelect = ({ activeView, onViewSelect, viewSchema }) => (
  <div className="eai-seg" role="group" aria-label="Graph view">
    {Object.entries(viewSchema).map(([key, view]) => {
      const { Icon, name } = view;
      const active = key === activeView;

      return (
        <button
          key={key}
          type="button"
          onClick={() => key !== activeView && onViewSelect(key)}
          className={`eai-seg-item px-2.5 ${active ? "eai-seg-item-active" : ""}`}
          aria-current={active ? "true" : undefined}
          /* The label is hidden below xl, so the button needs its own name there */
          aria-label={name}
          title={name}
        >
          <Icon className="h-4 w-4 shrink-0 [&_path]:stroke-current" />
          <span className="hidden xl:inline">{name}</span>
        </button>
      );
    })}
  </div>
);

export default TabViewSelect;
